import React, { useState } from 'react';
import Modal from '../../../components/Modals/Modal';
import styles from '../../../styles/modals.module.scss';
import Button from '../../../components/Buttons/Button';
import { useHistory } from 'react-router-dom';

import { Box, Typography, withStyles } from '@material-ui/core';
import Dropdown from '../../../components/Inputs/Dropdown';
import routes from '../../../constants/routes';
import SDialog from '../../../components/SDialog/SDialog';
import FlexColumn from '../../../components/FlexBox/FlexColumn';

const SelectIntegrator = ({ show, onClose, togglePopup, list, setIntegrator }) => {
  const [value, setValue] = useState({ id: '', name: '' });
  const history = useHistory();

  const WhiteTextTypography = withStyles({
    root: {
      color: '#483f94',
    },
  })(Typography);

  const handleClick = () => {
    setIntegrator(value);
    togglePopup('View');
  };
  return (
    <SDialog
      title='Add customer'
      open={show}
      onClose={() => {
        togglePopup('cancel');
        history.push(routes.customer.list);
      }}
      titleConfig={{
        variant: 'h5M'
      }}
      secondaryButtonConfig={{
        text: 'Cancel',
        onClick: () => {
          togglePopup('cancel');
          history.push(routes.customer.list);
        },
      }}
      primaryButtonConfig={{
        text: 'Continue',
        onClick: handleClick,
        disabled: !value?.id
      }}
      width='30rem'
    >
      <FlexColumn alignItems='start'>
        <Dropdown
          name="accountType"
          placeholder="Select Integrator"
          value={value.value}
          data={list}
          onChange={(data) => setValue({ value: data?.name, id: data?.id })}
        // disabled={isLoading}
        />
      </FlexColumn>
    </SDialog>
  );
};

export default SelectIntegrator;
